module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hydroware-inline-input"
  }, [_c('el-input', _vm._g(_vm._b({}, 'el-input', [_vm.$attrs, _vm.$props], false), _vm.$listeners), [_c('template', {
    slot: "prepend"
  }, [_vm._t("label", [_c('label', {
    staticClass: "el-form-item__label"
  }, [_c('span', {
    staticStyle: {
      "opacity": "0.7"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labeltext) + "\n        ")])])])], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2424a987"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/hydroware-inline-input.vue
// module id = 786
// module chunks = 1